import { clsx } from 'clsx';

import style from './style.module.scss';

export const TagGroup = props => <ul className={clsx(style['tag-group'], props.className)}>{props.children}</ul>;
